import { Converter } from '../types/converter';

export const radiationActivityConverter: Converter = {
  id: 'radiationActivity',
  name: 'Radiation Activity Converter',
  icon: 'Radio',
  categories: ['radiology'],
  units: [
    // SI unit and prefixes
    { name: 'Becquerel', symbol: 'Bq', factor: 1 },
    { name: 'Terabecquerel', symbol: 'TBq', factor: 1e12 },
    { name: 'Gigabecquerel', symbol: 'GBq', factor: 1e9 },
    { name: 'Megabecquerel', symbol: 'MBq', factor: 1e6 },
    { name: 'Kilobecquerel', symbol: 'kBq', factor: 1000 },
    { name: 'Millibecquerel', symbol: 'mBq', factor: 0.001 },
    
    // Traditional units
    { name: 'Curie', symbol: 'Ci', factor: 3.7e10 },
    { name: 'Kilocurie', symbol: 'kCi', factor: 3.7e13 },
    { name: 'Millicurie', symbol: 'mCi', factor: 3.7e7 },
    { name: 'Microcurie', symbol: 'µCi', factor: 3.7e4 },
    { name: 'Nanocurie', symbol: 'nCi', factor: 37 },
    { name: 'Picocurie', symbol: 'pCi', factor: 0.037 },
    
    // Other units
    { name: 'Rutherford', symbol: 'Rd', factor: 1e6 },
    { name: 'One/second', symbol: '1/s', factor: 1 },
    { name: 'Disintegrations/second', symbol: 'dps', factor: 1 },
    { name: 'Disintegrations/minute', symbol: 'dpm', factor: 1/60 }
  ]
};
